import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { PaletteMode, Theme } from '@mui/material';

export const getDesignTokens = (mode?: PaletteMode) =>
  ({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
    },
    typography: {
      fontFamily: 'Inter',
      htmlFontSize: 18,
      h1: {
        fontSize: '2.5rem',
        fontWeight: 700,
      },
      h2: {
        fontSize: '2rem',
        fontWeight: 700,
      },
      h3: {
        fontSize: '1.75rem',
        fontWeight: 700,
      },
      h4: {
        fontSize: '1.5rem',
        fontWeight: 700,
      },
      h5: {
        fontSize: '1rem',
        fontWeight: 500,
      },
      h6: {
        fontSize: '1rem',
        fontWeight: 300,
      },
      subtitle1: {
        fontSize: '1rem',
        fontWeight: 400,
      },
      subtitle2: {
        fontSize: '0.875rem',
        fontWeight: 400,
      },
      body1: {
        fontSize: '1rem',
        fontWeight: 400,
      },
      body2: {
        fontSize: '0.875rem',
        fontWeight: 400,
      },
    },
    palette: {
      mode,

      ...(mode === 'light'
        ? {
            // palette values for light mode
            primary: {
              main: '#2C74F6',
            },
            secondary: {
              main: '#090940',
            },
            error: {
              main: '#FF0000',
              light: 'rgba(223, 94, 107, 0.2)',
            },
            success: {
              main: '#00FF00',
              light: 'rgba(113, 182, 145, 0.2)',
            },
            text: {
              secondary: '#8a8a8a',
            },
          }
        : {
            // palette values for dark mode
            primary: {
              main: '#2C74F6',
            },
            secondary: {
              main: '#090940',
            },
            error: {
              main: '#FF0000',
              light: 'rgba(223, 94, 107, 0.2)',
            },
            success: {
              main: '#00FF00',
              light: 'rgba(113, 182, 145, 0.2)',
            },
            text: {
              secondary: '#8a8a8a',
            },
          }),
    },
  } as Theme);

export const borderColor = '#E7E7E7';
export const borderRadius = '5px';
export const borderThickness = '1px';
export const border = `${borderThickness} solid ${borderColor}`;
export const PRIMARY = '#2C74F6';
export const PROFIT = '#71b691';
export const LOSS = '#df5e6b';
